import ModalPassword from 'containers/ForgottenPassword/components/ModalPassword';
import React from 'react';
import { useSelector } from 'react-redux';

const ForgottenPasswordProvider = ({ children }) => {
  const { modalVisibility } = useSelector(state => state.resetPassword);
  if (modalVisibility) return <ModalPassword />;
  return <>{children}</>;
};

export default ForgottenPasswordProvider;
